import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import Globals from '../../../../Globals';
import Datepicker from '../../../bronson/Datepicker';
import ContractsService from '../../../../services/ContractsService';
import '../../../css/huerto/modalsFichaCliente.css';
import FunctionGeneral from '../functionsGeneral';

function ModalFichaClienteAddActividad(props) {
    const [typeValue, setTypeValue] = useState('');
    const [datePickerFromValue, setDatePickerFromValue] = useState(
        new FunctionGeneral().fechainicial()
    );
    const [inputAccion, setInputAccion] = useState('');
    const [inputTelefono, setinputTelefono] = useState(false);
    const [inputMail, setinputMail] = useState(false);
    const [inputConcesionario, setinputConcesionario] = useState(false);
    useEffect(() => {
        document.querySelector('#fecha-actividad').value = datePickerFromValue;
        changeAccion('NEWAccion');
        window.bronson.ComponentRegister.initAll();
    }, []);

    try {
        if (props.dataListTypeDecisions && typeValue === '')
            setTypeValue(props.dataListTypeDecisions[0].Value);
    } catch {}

    const onChangeTypeAccion = target => {
        setTypeValue(target.currentTarget.value);
    };

    const onchangeInputText = target => {
        if (target && target.target) {
            if (
                target.target.id === 'textAreaAddActividad' &&
                target.target.value.length < 195
            ) {
                var valueToSend = target.target.value;
                setInputAccion(valueToSend);
            }
        }
    };

    async function sendAccion() {
        changeAccion('GuardarAccion');
        props.setLoading(true);
        var _dataDecisionsAddList = await new ContractsService().addActionsDecisionsService(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            typeValue,
            inputAccion,
            datePickerFromValue,
            props.PolizaId
        );
        if (
            _dataDecisionsAddList &&
            _dataDecisionsAddList.statusCode === 200 &&
            _dataDecisionsAddList.body &&
            _dataDecisionsAddList.body.Result
        ) {
            var dataDecisionsList = await new ContractsService().readActionsDecisionsList(
                props.cookies.get(Globals.COOKIES.JWT).AccessToken,
                props.cookies.get(Globals.COOKIES.USER),
                props.FinancialOperationCode
            );

            if (
                dataDecisionsList &&
                dataDecisionsList.statusCode === 200 &&
                dataDecisionsList.body &&
                dataDecisionsList.body.Result
            ) {
                var _dataDecisionsList = JSON.parse(
                    dataDecisionsList.body.Result
                );
                props.setdataDecisions(_dataDecisionsList);
                setTimeout(() => props.setLoading(false), 1000);
                props.setModalAddActividad(false);
            }
        }
    }

    const onChangeFilterTextDate = target => {
        try {
            var ChangeValid = target.target.value.split('/');
            if (ChangeValid.length === 3)
                setDatePickerFromValue(target.target.value);
        } catch {}
    };
    const onChangeDatepickerFrom = event => {
        //let value = event.querySelector('input').value;
        setDatePickerFromValue(event);
    };

    async function changeAccion(action) {
        if (action === 'LLAMADA') {
            setinputTelefono(true);
            setinputMail(false);
            setinputConcesionario(false);
        } else if (action === 'EMAIL') {
            setinputTelefono(false);
            setinputMail(true);
            setinputConcesionario(false);
        } else if (action === 'CONCESIONARIO') {
            setinputTelefono(false);
            setinputMail(false);
            setinputConcesionario(true);
        }
        props.changeAccionLogs(action);
    }

    return (
        <React.Fragment>
            <div className="c-modal" aria-hidden={'false'}>
                <div className="c-modal__overlay js-modal-close"></div>
                <div
                    className="c-modal__wrapper modalFichaCliente"
                    role="dialog"
                    aria-labelledby="foo-bar-baz"
                >
                    <header className="c-modal__header">
                        <div className="o-layout__item u-11/12">
                            <div className="u-1/1">
                                <div className="c-icon c-icon--[semantic-chat] colorBlue iconContrato" />
                                <label className="u-h3 u-ml-xsmall">
                                    Contacto con cliente
                                </label>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/12">
                            <button
                                onClick={() => changeAccion('SALIR')}
                                className="c-modal__close-btn  js-modal-close"
                                type="button"
                                aria-label="Close this dialog window."
                            />
                        </div>
                    </header>

                    <div className="c-modal__content">
                        <div className="gridContainerModal o-layout">
                            <div className="o-layout__item u-1/1">
                                <p className="u-text-left">
                                    Reportando el resultado del contacto de tu
                                    cliente, nos ayudas a mejorar el algoritmo
                                    predictivo que te ayudará a saber cual es el
                                    mejor momento para plantearle una renovación
                                    a tu cliente.
                                </p>
                            </div>

                            <div className="o-layout__item u-1/1">
                                <label className="colorBlue registerAccion u-float-left">
                                    ¿Qué acción quieres registrar?
                                </label>
                            </div>
                            <div className="o-layout__item u-1/1 fc-margintop-10">
                                <div
                                    style={{ padding: '10px' }}
                                    className={
                                        'u-float-left' +
                                        (inputTelefono
                                            ? ' backgroundcolorBlue'
                                            : ' backgrounColorWhite')
                                    }
                                    onClick={() => changeAccion('LLAMADA')}
                                >
                                    <div className="u-1/1 u-text-center">
                                        <span
                                            className={
                                                'c-icon c-icon--[semantic-phone]' +
                                                (inputTelefono
                                                    ? ' u-text-white'
                                                    : ' u-text-brand')
                                            }
                                        />
                                    </div>
                                    <label
                                        className={
                                            'labelConsT u-text-center u-1/1' +
                                            (inputTelefono
                                                ? ' u-text-white'
                                                : ' u-text-brand')
                                        }
                                    >
                                        TELÉFONO
                                    </label>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '10px',
                                        padding: '7px',
                                    }}
                                    className={
                                        'u-float-left u-text-center' +
                                        (inputMail
                                            ? ' backgroundcolorBlue'
                                            : ' backgrounColorWhite')
                                    }
                                    onClick={() => changeAccion('EMAIL')}
                                >
                                    <div className="u-1/1 u-text-center">
                                        <span
                                            className={
                                                'c-icon c-icon--[email]' +
                                                (inputMail
                                                    ? ' u-text-white'
                                                    : ' u-text-brand')
                                            }
                                        />
                                    </div>
                                    <label
                                        className={
                                            'labelConsT u-text-center u-1/1' +
                                            (inputMail
                                                ? ' u-text-white'
                                                : ' u-text-brand')
                                        }
                                    >
                                        EMAIL
                                    </label>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '10px',
                                        padding: '7px',
                                    }}
                                    className={
                                        'u-float-left u-text-center' +
                                        (inputConcesionario
                                            ? ' backgroundcolorBlue'
                                            : ' backgrounColorWhite')
                                    }
                                    onClick={() =>
                                        changeAccion('CONCESIONARIO')
                                    }
                                >
                                    <div className="u-1/1 u-text-center">
                                        <span
                                            className={
                                                'c-icon c-icon--[dealer]' +
                                                (inputConcesionario
                                                    ? ' u-text-white'
                                                    : ' u-text-brand')
                                            }
                                        />
                                    </div>
                                    <label
                                        className={
                                            'labelConsT u-text-center u-1/1' +
                                            (inputConcesionario
                                                ? ' u-text-white'
                                                : ' u-text-brand')
                                        }
                                    >
                                        INSTALACIÓN
                                    </label>
                                </div>
                            </div>
                            {((inputMail && props.nomComponent[1] !== '') ||
                                (inputTelefono &&
                                    props.nomComponent[2] !== '')) && (
                                <div className="o-layout__item u-1/1 fc-margintop-10">
                                    <div className="o-layout__item u-10/12 modalAddClienteNombreComponent">
                                        <div>{props.nomComponent[0]}</div>
                                        {inputTelefono && (
                                            <div className="u-1/1">
                                                <span className="c-icon c-icon--xxsmallFC c-icon--[semantic-phone]  u-2/10" />
                                                <label className="labelConsT u-text-muted u-8/10">
                                                    {props.nomComponent[2]}
                                                </label>
                                            </div>
                                        )}
                                        {inputMail && (
                                            <div className="u-1/1">
                                                <span className="c-icon c-icon--xxsmallFC c-icon--[semantic-mail]  u-2/10" />
                                                <label className="labelConsT u-text-muted u-8/10">
                                                    {props.nomComponent[1]}
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="o-layout__item u-1/1 fc-margintop-10">
                                <label className="u-text-base u-1/1 u-text-left">
                                    Resultado con el Cliente
                                </label>
                                <div className="c-form-field__box u-4/5">
                                    <div className="c-input c-input--select">
                                        <select
                                            className="c-input__input"
                                            onChange={onChangeTypeAccion}
                                            defaultValue={typeValue}
                                        >
                                            {props.dataListTypeDecisions.map(
                                                typeDecision => (
                                                    <option
                                                        key={typeDecision.Text}
                                                        value={
                                                            typeDecision.Value
                                                        }
                                                    >
                                                        {typeDecision.Text}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="o-layout__item u-1/1 fc-margintop-10">
                                <label className="u-text-base u-1/1 u-text-left">
                                    ¿Cuándo se ha llevado a cabo la acción?
                                </label>
                                <div
                                    className="input-div u-1/3"
                                    onChange={onChangeFilterTextDate}
                                >
                                    <Datepicker
                                        options={{
                                            id: 'fecha-actividad',
                                            type: 'date',
                                            maxDate: new FunctionGeneral().fechainicial(),
                                        }}
                                        className="fecha-actividad"
                                        onChange={onChangeDatepickerFrom}
                                    ></Datepicker>
                                </div>
                            </div>

                            <div className="o-layout__item u-1/1 fc-margintop-10">
                                <label className="u-text-base u-1/1 u-text-left">
                                    Describe la acción
                                </label>
                                <div
                                    className="input-div u-1/1"
                                    onChange={onchangeInputText}
                                >
                                    <textarea
                                        className="textAreaAddActividad"
                                        id="textAreaAddActividad"
                                        value={inputAccion}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/2 u-text-center">
                            <button
                                className="CancelActividad c-btn--secondary c-btn u-float-right"
                                style={{ marginRight: '20px' }}
                                onClick={() => changeAccion('SALIR')}
                            >
                                CANCELAR
                            </button>
                        </div>
                        <div className="o-layout__item u-1/2 u-text-center">
                            <button
                                className="u-text-brand c-btn scoring-table-button u-float-left"
                                style={{ width: '60%' }}
                                onClick={() => sendAccion()}
                            >
                                GUARDAR ACCIÓN
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
export default withCookies(withRouter(ModalFichaClienteAddActividad));
